import './App.css';
import IframeComponent from './components/IframeComponent';

function App() {
  return (
    <div className="App">
      <IframeComponent src="https://docs.google.com/document/d/e/2PACX-1vQVt0K-MpqeBKet-FBP5si06Y8bWoR8lXZAlUxKPZhBBYpdgftj6I9ADat0m624Ed8acJMV8omeVzDB/pub?embedded=true"/>
    </div>
  );
}

export default App;
